const actions = {
    FETCH_RESULTS: 'FETCH_RESULTS',
    FETCH_RESULT: 'FETCH_RESULT',
    RESET_RESULT: 'RESET_RESULT',

    fetchResultsAction: (data) => {
        return {
            type: actions.FETCH_RESULTS,
            data: data
        };
    },
    resetResultFormAction: () => {
        return {
            type: actions.RESET_RESULT,
            data: null
        };
    },
    fetchResultAction: (data) => {
        return {
            type: actions.FETCH_RESULT,
            data: data
        };
    },
}

export default actions;
